(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nebbia-category-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  var groups = document.querySelectorAll('[data-gender-group]');
  if (!groups.length) return;

  function applyToGroup(group, g) {
    group.querySelectorAll('[data-gender-btn]').forEach(function (btn) {
      var on = btn.getAttribute('data-gender-btn') === g;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', String(on));
    });
    group.querySelectorAll('[data-gender-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-gender-panel') !== g;
    });
  }
  function selectAll(g) {
    var y = window.scrollY;
    groups.forEach(function (group) { applyToGroup(group, g); });
    if (window.scrollY !== y) window.scrollTo(0, y);
  }
  groups.forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gender-btn]');
      if (btn) selectAll(btn.getAttribute('data-gender-btn'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nebbia-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var header = document.getElementById('nb-header');
  if (!header) return;

  // Transparent-over-hero → solid once scrolled past the header's own height.
  if (header.dataset.transparent === 'true') {
    var toggleScrolled = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 60);
    };
    toggleScrolled();
    window.addEventListener('scroll', toggleScrolled, { passive: true });
  }

  // Touch support for the mega menu (desktop gets hover/focus for free via CSS).
  document.querySelectorAll('[data-nb-mega-trigger]').forEach(function (item) {
    var link = item.querySelector(':scope > .nb-header__navlink');
    var panel = item.querySelector('[data-nb-mega-panel]');
    if (!link || !panel) return;
    link.addEventListener('click', function (e) {
      if (!('ontouchstart' in window)) return;
      if (!item.classList.contains('is-open')) {
        e.preventDefault();
        document.querySelectorAll('.nb-header__navitem.is-open').forEach(function (o) { o.classList.remove('is-open'); });
        item.classList.add('is-open');
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nb-mega-trigger]')) {
      document.querySelectorAll('.nb-header__navitem.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    }
  });

  // Mobile off-canvas menu.
  var mobileNav = document.getElementById('nb-mobile-nav');
  document.querySelectorAll('[data-nb-mobile-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var willOpen = !mobileNav.classList.contains('is-open');
      mobileNav.classList.toggle('is-open', willOpen);
      mobileNav.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
      document.body.style.overflow = willOpen ? 'hidden' : '';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nebbia-hero"] && !Shopify.designMode) return;
  try {
    
// Scroll-reveal: adds .is-in to .reveal elements as they enter the viewport.
// Shared across all NEBBIA homepage sections (only needs to load once, from
// whichever section renders first — currently the hero).
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) return;

  (document.querySelector('.nb-home') || document.body).classList.add('reveal-ready');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  els.forEach(function (el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nebbia-product-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var vp = rail.querySelector('[data-rail-viewport]');
    if (!vp) return;

    function makeBtn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nb-rail__btn nb-rail__btn--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
      b.innerHTML = dir === 'prev'
        ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"></path></svg>'
        : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"></path></svg>';
      rail.appendChild(b);
      return b;
    }
    var prev = makeBtn('prev');
    var next = makeBtn('next');

    function pageWidth() {
      var card = vp.querySelector('.nb-product-card');
      var gap = parseFloat(getComputedStyle(vp).columnGap || '24') || 24;
      var cardW = card ? card.getBoundingClientRect().width + gap : vp.clientWidth * 0.8;
      var cards = Math.max(1, Math.floor(vp.clientWidth / cardW));
      return cardW * cards;
    }
    function update() {
      var max = vp.scrollWidth - vp.clientWidth;
      prev.disabled = vp.scrollLeft <= 2;
      next.disabled = vp.scrollLeft >= max - 2;
    }
    prev.addEventListener('click', function () { vp.scrollBy({ left: -pageWidth(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { vp.scrollBy({ left: pageWidth(), behavior: 'smooth' }); });

    var down = false, startX = 0, startScroll = 0, moved = false;
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false; startX = e.clientX; startScroll = vp.scrollLeft;
    });
    vp.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) {
        moved = true; vp.classList.add('is-grabbing');
        try { vp.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (moved) vp.scrollLeft = startScroll - dx;
    });
    function endDrag(e) {
      if (!down) return;
      down = false; vp.classList.remove('is-grabbing');
      try { if (e) vp.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    vp.addEventListener('pointerup', endDrag);
    vp.addEventListener('pointercancel', endDrag);
    vp.addEventListener('pointerleave', endDrag);
    vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    vp.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
